import { ApolloQueryResult } from '@apollo/client';
import { Exact, Scalars, StartQuestionMutation, TrialInfoQuery } from '@generated/graphql';

export enum AssessmentPage {
  Instructions = 'Instructions',
  Preview = 'Preview',
  Question = 'Question',
  Finish = 'Finish',
}

export type Question = NonNullable<TrialInfoQuery['trialInfo']['questionList']>[number];

export type AssessmentInfo = Omit<TrialInfoQuery['trialInfo'], 'questions'>;

export type QuestionFull = StartQuestionMutation['startQuestion'] | undefined;

export type RefetchTrialInfo = (
  variables?:
    | Partial<
        Exact<{
          trialId: Scalars['String']['input'];
        }>
      >
    | undefined,
) => Promise<ApolloQueryResult<TrialInfoQuery>>;
